import React, { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import dayjs from "dayjs";
import MonthGrid from "./MonthGrid";
import SheetHeaderClose from "./SheetHeaderClose";

interface Props {
  open: boolean;
  onClose: () => void;
  value: string | null;
  onApply: (value: string | null) => void;
}

export default function MonthPickerSheet({ open, onClose, value, onApply }: Props) {
  const [year, setYear] = useState(value ? dayjs(value).year() : dayjs().year());
  const [month, setMonth] = useState<number | null>(value ? dayjs(value).month() : null);

  useEffect(() => {
    if (!open) return;
    setYear(value ? dayjs(value).year() : dayjs().year());
    setMonth(value ? dayjs(value).month() : null);
  }, [open, value]);

  const apply = () => {
    onApply(month === null ? null : dayjs().year(year).month(month).format("YYYY-MM-01"));
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="auto"
      title="Travel Date"
      closable={false}
      extra={<SheetHeaderClose onClose={onClose} />}
      rootClassName="v2-sheet v2-sheet--months"
      footer={
        <Button type="primary" block className="v2-sheet__submit" onClick={apply}>
          Apply
        </Button>
      }
    >
      <MonthGrid year={year} onYearChange={setYear} month={month} onMonthChange={setMonth} />
    </Drawer>
  );
}
